export default [
    {
        path: 'entrada',
        component: () => import(
            /* webpackChunkName: 'almoxarifado-entrada' */
            '@/views/almoxarifado/entrada/Index'
        ),
        redirect: 'entrada/index',
        children: [
            {
                name: 'almoxarifado-entrada-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'almoxarifado-entrada' */
                    '@/views/almoxarifado/entrada/List.vue'
                ),
            },
            {
                name: 'almoxarifado-entrada-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'almoxarifado-entrada' */
                    '@/views/almoxarifado/entrada/Form.vue'
                ),
            },
            {
                name: 'almoxarifado-entrada-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'almoxarifado-entrada' */
                    '@/views/almoxarifado/entrada/Form.vue'
                ),
            },
        ],
    },
]